var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmailInbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1939_16115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20V39.8198C16 42.4386 17.2723 44.8872 19.4628 46.3224C26.2334 50.7584 41.16 60 48 60C54.84 60 69.7666 50.7584 76.5372 46.3224C78.7276 44.8872 80 42.4386 80 39.8198V20C80 13.3726 74.6274 8 68 8H28C21.3726 8 16 13.3726 16 20ZM31 20.0002C29.3432 20.0002 28 21.3434 28 23.0002C28 24.657 29.3432 26.0002 31 26.0002H49C50.6568 26.0002 52 24.657 52 23.0002C52 21.3434 50.6568 20.0002 49 20.0002H31ZM31 34.0002C29.3432 34.0002 28 35.3434 28 37.0002C28 38.657 29.3432 40.0002 31 40.0002H61C62.6568 40.0002 64 38.657 64 37.0002C64 35.3434 62.6568 34.0002 61 34.0002H31Z",
    fill: "#FFD666"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter1_i_1939_16115)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20V39.8198C16 42.4386 17.2723 44.8872 19.4628 46.3224C26.2334 50.7584 41.16 60 48 60C54.84 60 69.7666 50.7584 76.5372 46.3224C78.7276 44.8872 80 42.4386 80 39.8198V20C80 13.3726 74.6274 8 68 8H28C21.3726 8 16 13.3726 16 20ZM31 20.0002C29.3432 20.0002 28 21.3434 28 23.0002C28 24.657 29.3432 26.0002 31 26.0002H49C50.6568 26.0002 52 24.657 52 23.0002C52 21.3434 50.6568 20.0002 49 20.0002H31ZM31 34.0002C29.3432 34.0002 28 35.3434 28 37.0002C28 38.657 29.3432 40.0002 31 40.0002H61C62.6568 40.0002 64 38.657 64 37.0002C64 35.3434 62.6568 34.0002 61 34.0002H31Z",
    fill: "white",
    fillOpacity: 0.08
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23C28 21.3432 29.3432 20 31 20H49C50.6568 20 52 21.3432 52 23C52 24.6568 50.6568 26 49 26H31C29.3432 26 28 24.6568 28 23Z",
    fill: "#B76E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 37C28 35.3432 29.3432 34 31 34H61C62.6568 34 64 35.3432 64 37C64 38.6568 62.6568 40 61 40H31C29.3432 40 28 38.6568 28 37Z",
    fill: "#B76E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.0039C13.962 26.5167 12.1609 27.9002 10.7158 29.0303C8.30778 30.9133 6.79834 33.6903 6.59464 36.7403C6.31746 40.8907 6 47.8579 6 57.9999C6 67.5911 6.56784 74.3429 7.09838 78.5583C7.53582 82.0339 9.86276 84.7901 13.2935 85.4983C18.7945 86.6337 29.2988 87.9999 48 87.9999C66.7012 87.9999 77.2056 86.6337 82.7064 85.4983C86.1372 84.7901 88.4642 82.0339 88.9016 78.5583C89.4322 74.3429 90 67.5911 90 57.9999C90 47.8579 89.6826 40.8907 89.4054 36.7403C89.2016 33.6903 87.6922 30.9133 85.2842 29.0303C83.8391 27.9002 82.038 26.5167 80 25.0039V39.8197C80 42.4385 78.7276 44.8871 76.5372 46.3223C69.7666 50.7583 54.84 59.9999 48 59.9999C41.16 59.9999 26.2334 50.7583 19.4628 46.3223C17.2723 44.8871 16 42.4385 16 39.8197V25.0039Z",
    fill: "#225CA6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter2_i_1939_16115)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.0039C13.962 26.5167 12.1609 27.9002 10.7158 29.0303C8.30778 30.9133 6.79834 33.6903 6.59464 36.7403C6.31746 40.8907 6 47.8579 6 57.9999C6 67.5911 6.56784 74.3429 7.09838 78.5583C7.53582 82.0339 9.86276 84.7901 13.2935 85.4983C18.7945 86.6337 29.2988 87.9999 48 87.9999C66.7012 87.9999 77.2056 86.6337 82.7064 85.4983C86.1372 84.7901 88.4642 82.0339 88.9016 78.5583C89.4322 74.3429 90 67.5911 90 57.9999C90 47.8579 89.6826 40.8907 89.4054 36.7403C89.2016 33.6903 87.6922 30.9133 85.2842 29.0303C83.8391 27.9002 82.038 26.5167 80 25.0039V39.8197C80 42.4385 78.7276 44.8871 76.5372 46.3223C69.7666 50.7583 54.84 59.9999 48 59.9999C41.16 59.9999 26.2334 50.7583 19.4628 46.3223C17.2723 44.8871 16 42.4385 16 39.8197V25.0039Z",
    fill: "white",
    fillOpacity: 0.08
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1939_16115",
    x: 12,
    y: 4,
    width: 80,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.431373 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1939_16115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1939_16115",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.431373 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1939_16115"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1939_16115",
    x: 14,
    y: 6,
    width: 66,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1939_16115"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1939_16115",
    x: 4,
    y: 23.0039,
    width: 86,
    height: 64.9961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1939_16115"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmailInbox);
export default __webpack_public_path__ + "static/media/ic-email-inbox.59e0a5156fb3d025b9f775e38a5eadeb.svg";
export { ForwardRef as ReactComponent };